<template>
  <!--
    Where a PRESET ship-to goes (card #402): the server's "what it is" line
    and its "Ships to <name, address>, set by <store>" sentence, printed
    verbatim. Renders nothing without a sentence -- a shopper who typed the
    address is not told it back, and a legacy order claims no source.
    Text interpolation only (escaped); never v-html.
  -->
  <div v-if="disclosure" class="order-ship-to" :data-testid="testidPrefix">
    <div
      v-if="meaning"
      class="text-subtitle-2 text-grey-darken-1"
      :data-testid="`${testidPrefix}-meaning`"
    >
      {{ meaning }}
    </div>
    <div class="text-body-1" :data-testid="`${testidPrefix}-disclosure`">
      {{ disclosure }}
    </div>
  </div>
</template>

<script>
export default {
  name: "OrderShipToNotice",

  props: {
    /** `{ meaning, disclosure }` from the server, or null. */
    shipTo: { type: Object, default: null },
    /** Root data-testid; the two lines add `-meaning` / `-disclosure`. */
    testidPrefix: { type: String, default: "order-ship-to" },
  },

  computed: {
    disclosure() {
      const v = this.shipTo && this.shipTo.disclosure;
      return typeof v === "string" && v.trim() ? v : "";
    },
    meaning() {
      const v = this.shipTo && this.shipTo.meaning;
      return typeof v === "string" && v.trim() ? v : "";
    },
  },
};
</script>
